import { useEffect, useState } from 'react';

import { useLocalStorage } from '@xing-com/crate-hooks-use-web-storage';
import { EXTERNAL_APPLY_FLOW_LOCALSTORAGE_KEY } from '@xing-com/crate-jobs-constants';

export function useIsExternalApplicationFlowEnabled(isPaidJob: boolean): {
  isExternalApplicationFlowEnabled: boolean;
} {
  const [isRegisterFlowCompleted, setIsRegisterFlowCompleted] = useState(false);

  const [externalApplicationFlag] = useLocalStorage<{ completed: boolean }>(
    EXTERNAL_APPLY_FLOW_LOCALSTORAGE_KEY,
    { completed: false }
  );

  const isExternalApplicationFlowEnabled =
    !isPaidJob && !isRegisterFlowCompleted;

  useEffect(() => {
    // the flag is stored on browser side so we update it after render
    setIsRegisterFlowCompleted(externalApplicationFlag.completed);
  }, [externalApplicationFlag.completed]);

  return {
    isExternalApplicationFlowEnabled,
  };
}
